export const environment = {
  production: false,
  hmr: true,
  // serverUrl: 'https://uatprocureapi.elitetraveltech.in',
  // serverUrl: 'https://172.17.211.194:1007',
  // serverUrl: 'http://10.22.32.194:1007', //rajhans

  serverUrl: 'https://procurementapi.elitetraveltech.in',
  // serverUrl: 'https://procurementapi.elitetraveltech.in',
  //  serverUrl: 'http://192.168.20.165:8000', //ashutosh
  // serverUrl: 'https://procurementapi.elitetraveltech.in',
  // serverUrl: 'https://procurementapi.elitetraveltech.in',
  //  webserver: 'ws://192.168.20.165:8000',
  // serverUrl: 'http://localhost:1003', //navneet
  aiurl: "https://aiprocure.elitetraveltech.in/analyse",
  // aiurl: 'http://192.168.20.241:6789/analyse',

  // serverUrl: 'http://192.168.20.162:1007', //yash
  // serverUrl: 'http://localhost:8000', //vishal
  defaultLanguage: 'Label',
  supportedLanguages: ['Label', 'TMSA'],
};